module.exports = __webpack_public_path__ + "src/assets/textures/molar/molar_scene_planes_big_lambert7_AO.jpg";